interface SubWave {
    actor:DictNames;
    count:number;
    timeFromPrevSec:number;
    distrib:string;
    lengthSec:number;
    index?:number;
}
interface Wave {
    name?:string;
    subWaves:Array<SubWave>;
    index?:number;
}
class WavesConfig {
    waves:Array<Wave> = [
        {
            name:'start',
            subWaves:[
                {
                    actor:DictNames.rabbit,
                    count: 1,
                    timeFromPrevSec:0,
                    distrib: '500',
                    lengthSec: 0
                }
            ]
        },
        {
            name:'start01',
            subWaves:[
                {
                    actor:DictNames.rabbit,
                    count: 1,
                    timeFromPrevSec:0,
                    distrib: '500',
                    lengthSec: 0
                }
            ]
        },
        {
            name:'start1',
            subWaves:[
                {
                    actor:DictNames.rabbit,
                    count: 60,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 5
                }
            ]
        },
        {
            name:'1',
            subWaves:[
                {
                    actor:DictNames.rabbit,
                    count: 100,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 5
                }
            ]
        },
        {
            name:'2',
            subWaves:[
                {
                    actor:DictNames.rabbit,
                    count: 1000,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 5
                }
            ]
        },
        {
            name:'3',
            subWaves:[
                {
                    actor:DictNames.rabbit,
                    count: 500,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 3
                }
            ]
        },
        {
            name:'4',
            subWaves:[
                {
                    actor:DictNames.bear,
                    count: 5,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 10
                }
            ]
        },
        {
            name:'5',
            subWaves:[
                {
                    actor:DictNames.rabbit,
                    count: 500,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 3
                },
                {
                    actor:DictNames.bear,
                    count: 10,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 10
                }
            ]
        },
        {
            name:'6pony',
            subWaves:[
                {
                    actor:DictNames.pony,
                    count: 1,
                    timeFromPrevSec:0,
                    distrib: '700',
                    lengthSec: 0
                }
            ]
        },
        {
            name:'7timeout',
            subWaves:[
                {
                    actor:DictNames.rabbit,
                    count: 10,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 7
                }
            ]
        },
        {
            name:'8',
            subWaves:[
                {
                    actor:DictNames.rabbit,
                    count: 2000,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 10
                },
                {
                    actor:DictNames.bear,
                    count: 50,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 10
                }
            ]
        },
        {
            name:'9',
            subWaves:[
                {
                    actor:DictNames.rabbit,
                    count: 5000,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 10
                },
                {
                    actor:DictNames.bear,
                    count: 100,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 10
                }
            ]
        },
        {
            name:'10',
            subWaves:[
                {
                    actor:DictNames.rabbit,
                    count: 100,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 10
                },
            ]
        },
        {
            name:'firstHell',
            subWaves:[
                {
                    actor:DictNames.rabbit,
                    count: 5000,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 10
                },
                {
                    actor:DictNames.bear,
                    count: 100,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 5
                },
                {
                    actor:DictNames.pony,
                    count: 1,
                    timeFromPrevSec:5,
                    distrib: '100 + 5d800/5',
                    lengthSec: 0
                }
            ]
        },
        {
            name:'hellTimeout',
            subWaves:[
                {
                    actor:DictNames.rabbit,
                    count: 10,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 7
                }
            ]
        },
        {
            name:'threePony',
            subWaves:[
                {
                    actor:DictNames.pony,
                    count: 3,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 7
                }
            ]
        },
        {
            name:'cycle1',
            subWaves:[
                {
                    actor:DictNames.rabbit,
                    count: 5000,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 10
                },
                {
                    actor:DictNames.bear,
                    count: 100,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 5
                },
                {
                    actor:DictNames.pony,
                    count: 1,
                    timeFromPrevSec:5,
                    distrib: '100 + 5d800/5',
                    lengthSec: 0
                }
            ]
        },
        {
            name:'cycle1.1',
            subWaves:[
                {
                    actor:DictNames.rabbit,
                    count: 5000,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 10
                },
                {
                    actor:DictNames.bear,
                    count: 500,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 5
                },
            ]
        },
        {
            name:'cycle1.2',
            subWaves:[
                {
                    actor:DictNames.rabbit,
                    count: 500,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 10
                }
            ]
        },
        {
            name:'cycle1.3',
            subWaves:[
                {
                    actor:DictNames.rabbit,
                    count: 5000,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 10
                },
                {
                    actor:DictNames.bear,
                    count: 1000,
                    timeFromPrevSec:0,
                    distrib: '100 + 5d800/5',
                    lengthSec: 5
                },
            ]
        },
    ]
}